
(function showLoadingDirectiveDefinition() {

    'use strict';

    // esta directiva está pensada para usar en anchors.
    angular.module('Loading')
        .directive('buttonLoading', function() {
            return {
                restrict: 'A',
                link: function(scope, element, attrs) {

                    element.addClass('button-loading-padding');

                    var div = angular.element('<div></div>');
                    div.addClass('button-loading');
                    
                    scope.$watch(attrs.buttonLoading, function (value) {
                        if (value) {
                            element.removeClass('button-loading-padding');
                            element.append(div);
                        } else {
                            element.addClass('button-loading-padding');
                            div.remove();
                        }
                    });
                }
            };
        });

})();